import { combineReducers } from "@reduxjs/toolkit";

import EntityStateSlice from "./slices/EntityStateSlice";
import FiltersSlice from "./slices/FiltersSlice";
import OverviewSlice from "./slices/OverviewSlice";
import TagsSlice from "./slices/TagsSlice";
import DetailsSlice from "./slices/DetailsSlice";
import UsersSlice from "./slices/UsersSlice";
import GroupsSlice from "./slices/GroupsSlice";

const edit = combineReducers({
  users: UsersSlice,
  groups: GroupsSlice,
});

export const SCORMReducer = combineReducers({
  entityState: EntityStateSlice,
  overview: OverviewSlice,
  details: DetailsSlice,
  filters: FiltersSlice,
  tags: TagsSlice,
  edit,
});
